/** Matches schema `Mutation.createPalette(input: PaletteFieldInput): PaletteItem`. */
export const mutationCreatePalette = `
mutation createPalette($input: PaletteFieldInput) {
	createPalette(input: $input) {
		paletteId
		label
		light
		dark
	}
}
`;
